// Vendor Libs
import {toLower} from 'lodash';

const initialState = {
    error: null,
    fetched: false,
    fetching: false,
    stores: {},
    user: null,
};

const actions = {
    PREFERENCES_FETCH: state => ({...state, error: null, fetching: true, fetched: false}),

    PREFERENCES_FETCH_FULFILLED: state => ({...state, error: null, fetched: true, fetching: false}),

    PREFERENCES_FETCH_REJECTED: (state, {error}) => ({...state, error, fetched: true, fetching: false}),

    PREFERENCES_INIT: state => ({...state, error: null}),

    PREFERENCES_LOAD: (state, {stores, user}) => ({...state, stores, user, fetched: true, fetching: false}),

    PREFERENCES_RESET: state => ({...initialState}),

    PREFERENCES_SAVE: (state, {stores, user}) => ({
        ...state,
        stores,
        user,
        fetched: true,
        fetching: false,
        error: null,
    }),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
